import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

export default function LeaveGroupConfirm({ open, onClose, onConfirm, loading }) {
  const { t } = useScriptMode();
  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="xs" fullWidth sx={{ zIndex: 1500 }}>
      <DialogTitle>{t("group_leave_confirm_title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("group_leave_confirm_body")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("group_leave_confirm_cancel")}
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
        >
          {t("group_leave_confirm_confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
